import React from 'react';
import './SocialButton.css';

const SocialButton = ({ icon, text, onClick }) => {
  return (
    <button className="social-button" onClick={onClick}>
      <span className="social-button-icon">{icon}</span>
      <span className="social-button-text">{text}</span>
    </button>
  );
};

export default SocialButton;
